export * from './lib/inflector-interceptor.service';
